module.exports = __webpack_public_path__ + "static/media/apple-icon.00587615.svg";